const TOGGLE = {
    hide(that, node) {
        let form      = that.closest('form');
        let container = form.querySelector('[data-toggle="' + node + '"]');
        if (container === null) return;
        container.classList.add('is-hidden');
    },
    show(that, node) {
        let form      = that.closest('form');
        let container = form.querySelector('[data-toggle="' + node + '"]');
        if (container === null) return;
        container.classList.remove('is-hidden');
    }
}